import { createAction, props } from '@ngrx/store';
import { UserSession } from 'src/app/business/core/services/session-manager/session-manager.service';

export const setCurrentUser = createAction(
    '[Auth] Set Current User',
    props<{ user: UserSession | null }>()
);
